import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import api from "@/lib/api";

export default function AdminPeoplePanel() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/admin/people").then((r) => setData(r.data)).catch(() => toast.error("Couldn't load users"));
  }, []);

  const exportCsv = async () => {
    try {
      const r = await api.get("/admin/people.csv", { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      Object.assign(document.createElement("a"), { href: url, download: "studivault-users-leads.csv" }).click();
      URL.revokeObjectURL(url);
    } catch { toast.error("CSV export failed"); }
  };

  if (!data) return <p className="text-[#8E8B99] text-sm">Loading…</p>;
  const needle = q.trim().toLowerCase();
  const rows = data.people.filter((p) => !needle || `${p.name} ${p.email} ${p.type}`.toLowerCase().includes(needle));

  return (
    <div data-testid="admin-people-panel">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <span className="text-sm text-[#B0AEBC]" data-testid="admin-people-counts">{data.users} users · {data.leads} leads</span>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, email, type"
          className="input max-w-xs" aria-label="Search people" data-testid="admin-people-search" />
        <button onClick={exportCsv} className="btn btn-primary px-4 py-2 text-[13px] ml-auto" data-testid="admin-people-export-csv">
          <Download size={14} /> Export CSV
        </button>
      </div>
      <div className="overflow-x-auto rounded-xl border border-[#2a2a3e]">
        <table className="w-full text-[13px]">
          <thead className="text-left text-[#8E8B99] bg-[#12121c]">
            <tr>{["Kind", "Name", "Email", "Phone", "Business/Type", "Plan", "Signup date"].map((h) => <th key={h} className="px-3 py-2 font-medium">{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((p, i) => (
              <tr key={`${p.kind}-${p.email}-${i}`} className="border-t border-[#2a2a3e]">
                <td className="px-3 py-2 capitalize">{p.kind}</td>
                <td className="px-3 py-2">{p.name || "—"}</td>
                <td className="px-3 py-2">{p.email}</td>
                <td className="px-3 py-2">{p.phone || "—"}</td>
                <td className="px-3 py-2">{p.type}</td>
                <td className="px-3 py-2 uppercase">{p.plan || "—"}</td>
                <td className="px-3 py-2 whitespace-nowrap">{p.signup_date ? new Date(p.signup_date).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
